const fontFamily = 'DM Sans';

const fontSizes = {
  h1: '25px',
  h2: '18px',
  h3: '15px',
  extraSmall: '11px',
  small: '13px',
  medium: '14px',
  regular: '15px',
};

const lineHeights = {
  small: '130%',
  regular: '150%',
};

const fontWeights = {
  regular: 400,
  bold: 700,
};

export { fontFamily, fontSizes, lineHeights, fontWeights };
